<template>
  <div>
    <h4 class="content-block">Gaji Baru</h4>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <p class="text-muted font-weight-light">Peraturan Penggajian</p>
        <div class="row">
          <!-- <div class="editors"> -->
          <div class="editors-container">
            <div class="col">
              <DxSelectBox
                :dataSource="bulanSource"
                valueExpr="id"
                displayExpr="name"
                width="100%"
                label="Periode Bulan"
                placeholder="Periode Bulan"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.bulan"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="tahunSource"
                width="100%"
                label="Periode Tahun"
                placeholder="Periode Tahun"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.tahun"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="pegawaiStatusSource"
                valueExpr="id"
                displayExpr="nama"
                width="100%"
                label="Pilih Pegawai"
                placeholder="Pegawai"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                @value-changed="onPegawaiChanged"
                v-model="filters.pegawai_status_id"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxSelectBox
                :dataSource="skemaGajiSource"
                valueExpr="id"
                displayExpr="nama"
                width="100%"
                label="Pilih Skema Penggajian"
                placeholder="Skema Penggajian"
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                v-model="filters.gaji_skema_id"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxSelectBox>
            </div>
            <div class="col" style="padding-left: 10px">
              <DxButton
                @click="validateFilter"
                text="Buat Gaji"
                styling-mode="filled"
                type="default"
                class="validate"
                style="float: left"
              />
              <!-- <button class="btn btn-primary float-left mr-2">Button</button> -->
            </div>
          </div>
          <!-- </div> editors-->
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        Note: Orderby error, query blm diedit, filter OK
        <DxDataGrid
          v-if="gridShowHonor"
          ref="gridRefHonor"
          id="gridHonor"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          key-expr="id"
          @editor-preparing="oneditorpreparing"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @option-changed="onPageChanged($event, 'gridRefHonor')"
          @load="onDataGridLoad"
          @exporting="onExporting"
          :columns="columnsHonor"
          :focused-row-enabled="true"
          :focused-row-index="0"
        >
          <DxFilterRow :visible="true" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" :allow-export-selected-data="true" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
            mode="row"
          />
          <DxToolbar>
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>

          <DxSelection mode="multiple" />
          <DxColumnFixing :enabled="true" />
          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template>
        </DxDataGrid>

        <DxDataGrid
          v-if="gridShowKontrak"
          ref="gridRefKontrak"
          id="gridKontrak"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          key-expr="id"
          @editor-preparing="oneditorpreparing"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @option-changed="onPageChanged($event, 'gridRefKontrak')"
          @load="onDataGridLoad"
          @exporting="onExporting"
          :columns="columnsKontrak"
          :focused-row-enabled="true"
          :focused-row-index="0"
        >
          <DxFilterRow :visible="true" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" :allow-export-selected-data="true" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
            mode="row"
          />
          <DxToolbar>
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>

          <DxSelection mode="multiple" />
          <DxColumnFixing :enabled="true" />
          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template>
        </DxDataGrid>

        <DxDataGrid
          v-if="gridShowTetap"
          ref="gridRefTetap"
          id="gridTetap"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          key-expr="id"
          @editor-preparing="oneditorpreparing"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @option-changed="onPageChanged($event, 'gridRefTetap')"
          @load="onDataGridLoad"
          @exporting="onExporting"
          :columns="columnsTetap"
          :focused-row-enabled="true"
          :focused-row-index="0"
        >
          <DxFilterRow :visible="true" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" :allow-export-selected-data="true" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
            mode="row"
          />
          <DxToolbar>
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>

          <DxSelection mode="multiple" />
          <DxColumnFixing :enabled="true" />
          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import axios from "axios";
import notify from "devextreme/ui/notify";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import DxButton from "devextreme-vue/button";
import DxSelectBox from "devextreme-vue/select-box";
import ODataStore from "devextreme/data/odata/store";
import { DateTime } from "luxon";
import DataSource from "devextreme/data/data_source";
import _ from "lodash";
// import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxToolbar,
} from "devextreme-vue/data-grid";
// import { toHandlerKey } from "vue";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
//GAGAL
const months = [
  { name: "Januari", id: 1 },
  { name: "Februari", id: 2 },
  { name: "Maret", id: 3 },
  { name: "April", id: 4 },
  { name: "Mei", id: 5 },
  { name: "Juni", id: 6 },
  { name: "Juli", id: 7 },
  { name: "Agustus", id: 8 },
  { name: "September", id: 9 },
  { name: "Oktober", id: 10 },
  { name: "November", id: 11 },
  { name: "Desember", id: 12 },
];

const currentYear = DateTime.now().toFormat("yyyy");
const currentMonth = DateTime.now().toFormat("M");
const years = [currentYear, Number(currentYear) + 1];

export default {
  components: {
    DxSelectBox,
    DxButton,
    DxValidator,
    DxRequiredRule,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxToolbar,
    // DxDropDownButton,
  },
  data() {
    return {
      gridShowHonor: false,
      gridShowKontrak: false,
      gridShowTetap: false,
      columnsHonor: null,
      columnsKontrak: null,

      golonganSource: new ODataStore({
        url: "http://127.0.0.1/odata/Golongans",
        key: "id",
      }),
      pegawaiSource: new ODataStore({
        url: "http://127.0.0.1/odata/SimpegPegawais",
        key: "id",
      }),
      numberingPageSize: 10,
      numberingPageNumber: 0,
      // dataSource: [
      //   {
      //     ID: 0,
      //     pegawai_id: "",
      //   },
      // ],
      dataSource: [],
      filters: {
        bulan: Number(currentMonth),
        tahun: currentYear,
        pegawai_status_id: "",
        gaji_skema_id: "",
      },
      bulanSource: months,
      tahunSource: years,
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",
      pegawaiStatusSource: new ODataStore({
        url: "http://127.0.0.1/odata/PegawaiStatuses",
        key: "id",
      }),
      skemaGajiSource: null,
    };
  },
  computed: {
    columnsBase() {
      return [
        {
          dataField: "created_at",
          caption: "No.",
          cellTemplate: "numberingTemplate",
          allowFiltering: false,
          allowSorting: false,
        },
        {
          dataField: "riwayatPekerjaan.pegawai_id",
          caption: "NIK",
          lookup: {
            dataSource: this.pegawaiSource,
            valueExpr: "id",
            displayExpr: "nik",
          },
        },
        {
          dataField: "riwayatPekerjaan.pegawai_id",
          caption: "Nama",
          lookup: {
            dataSource: this.pegawaiSource,
            valueExpr: "id",
            displayExpr: "nama",
          },
        },
        {
          dataField: "riwayatGolongan.golongan_id",
          caption: "Gol.",
          lookup: {
            dataSource: this.golonganSource,
            valueExpr: "id",
            displayExpr: "nama",
          },
        },
      ];
    },
  },
  async mounted() {
    // this.columnsHonor = await this.getDatagridColumns(3);
    // this.columnsKontrak = await this.getDatagridColumns(4);
    this.columnsHonor = _.concat(
      _.cloneDeep(this.columnsBase),
      await this.getDatagridColumns(3)
    );
    this.columnsKontrak = _.concat(
      _.cloneDeep(this.columnsBase),
      await this.getDatagridColumns(4)
    );
    this.columnsTetap = _.concat(
      _.cloneDeep(this.columnsBase),
      await this.getDatagridColumns(2)
    );
  },

  methods: {
    async getDatagridColumns(pegawaiStatusId) {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      var data = {
        pegawai_status_id: pegawaiStatusId,
      };
      const response = await axios.post(
        "http://127.0.0.1/api/return_gaji_columns",
        data,
        config
      );
      return response.data;
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Gaji");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Gaji Pegawai " +
              this.filters.pegawai_status_id +
              " Periode Bulan " +
              this.filters.bulan +
              " " +
              this.filters.tahun +
              ".xlsx"
          );
        });
      });
      e.cancel = true;
    },

    onDataGridLoad() {
      const datagrid = this.$refs.gridRef.instance;
      datagrid.endCustomLoading();
    },
    onPageChanged(e, gridRef) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs[gridRef].instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },

    validateFilter(e) {
      const result = e.validationGroup.validate();

      if (!result.isValid) return 0;

      var check = new ODataStore({
        url:
          "http://127.0.0.1/odata/PegawaiGajis?$filter=month(tgl_gaji) eq " +
          this.filters.bulan +
          " and year(tgl_gaji) eq " +
          this.filters.tahun +
          " and gaji_skema_id eq " +
          this.filters.gaji_skema_id +
          "&$top=1",
        key: "id",
        version: 4,
        beforeSend: function (e) {
          e.headers = {
            "odata-version": "4.0",
          };
        },
      });
      check.totalCount().then(
        (data) => {
          if (data > 0) {
            notify("PENGGAJIAN PADA PERIODE INI SUDAH DILAKSANAKAN", "error");
          } else {
            //generate gaji!!
            this.generateGaji();
          }
        },
        (error) => {
          console.log(error);
        }
      );

      //tambahkan limit, tidak boleh generate gaji yang sudah digenerate!
    },

    async generateGaji() {
      //reset datagrid col, biar ga nge add!

      const config = {
        headers: {
          "content-type": "application/json",
        },
      };
      // let dataFin = JSON.stringify(data);
      var data = {
        bulan: this.filters.bulan,
        tahun: this.filters.tahun,
        gaji_skema_id: this.filters.gaji_skema_id,
        pegawai_status_id: this.filters.pegawai_status_id,
      };
      await axios
        // .post("http://127.0.0.1/api/return_gaji", data, config)
        //WARNING TODO NANTI UBAH URL
        .post("http://127.0.0.1/api/gaji_final_tetap", data, config)
        // .post("http://127.0.0.1/api/gaji_final_kontrak_honor", data, config)
        .then((response) => {
          notify(response.data.message, "success");
          // const datagrid = this.$refs.gridRef.instance;
          // datagrid.state({});
          // datagrid.beginCustomLoading("Loading...");

          // this.addColumn(response.data.columns);
          this.getGaji();
        })
        .catch((error) => {
          console.log(error);
          notify("gagal generate gaji", "error");
        });
    },

    async getGaji() {
      // this.dataSource = await getGaji();
      // var tempGajiSkemaId = this.filters.gaji_skema_id;
      // var tempTgl = this.filters.tahun + "-" + this.filters.bulan + "-01";
      if (this.filters.pegawai_status_id == 3) {
        this.gridShowHonor = true;
        this.gridShowKontrak = false;
        this.gridShowTetap = false;
      } else if (this.filters.pegawai_status_id == 4) {
        this.gridShowHonor = false;
        this.gridShowKontrak = true;
        this.gridShowTetap = false;
      } else if (this.filters.pegawai_status_id == 2) {
        this.gridShowHonor = false;
        this.gridShowKontrak = false;
        this.gridShowTetap = true;
      }
      this.dataSource = new DataSource({
        store: new ODataStore({
          // ODataStore is configured here
          url: "http://127.0.0.1/odata/PegawaiGajis",
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };

            if (hasFilterNestedTable(e.params.$filter)) {
              e.params.$filter = convertDatagridFilterNested(
                e.params.$filter,
                "riwayatPekerjaan"
              );
              e.params.$filter = convertDatagridFilterNested(
                e.params.$filter,
                "riwayatGolongan"
              );
              e.params.$filter = convertDatagridFilterNestedGajiDetails(
                e.params.$filter
              );
            }
          },
        }),

        // expand: [
        //   "simpegPegawai,pegawaiGajiDetails,pegawaiGajiDetails($expand=gajiSkemaKomponen),pegawaiGajiDetails($expand=gajiSkemaKomponen($expand=gajiItem))",
        // ],
        expand: [
          "riwayatPekerjaan,riwayatGolongan,pegawaiGajiDetails,pegawaiGajiDetails($expand=gajiSkemaKomponen),pegawaiGajiDetails($expand=gajiSkemaKomponen($expand=gajiItem))",
        ],
        filter: [
          ["gaji_skema_id", this.filters.gaji_skema_id],
          "and",
          ["tgl_gaji", this.filters.tahun + "-" + this.filters.bulan + "-01"],
        ],
        // [["gaji_skema_id", 2], "and", ["tgl_gaji", "2023-10-01"]],
      });
    },
    onPegawaiChanged(e) {
      this.filters.gaji_skema_id = "";
      var skemaId = e.value;
      this.skemaGajiSource = new ODataStore({
        url:
          "http://127.0.0.1/odata/GajiSkemas?$filter=pegawai_status_id eq " +
          skemaId,
        key: "id",
      });
    },
  },
};

function hasFilterNestedTable(str) {
  return (
    _.includes(str, "/") ||
    _.includes(str, "[") ||
    _.includes(str, "]") ||
    _.includes(str, "riwayatPekerjaan/") ||
    _.includes(str, "pegawaiGajiDetails/") ||
    _.includes(str, "riwayatGolongan/")
  );
}

function convertDatagridFilterNested(filter, regVar) {
  var regex = new RegExp(`\\(${regVar}\\/[^)]+\\)`, "g");
  var occurrences = filter.match(regex);
  if (occurrences != null) {
    //biar dapat ['(pegawaiGajiDetails[0]/jml eq 23)', '(pegawaiGajiDetails[1]/jml eq 23)']
    var modifiedArr = occurrences.map((str) => {
      var modifiedString = str
        .replace(/\[\d+\]/g, "")
        .replace(
          new RegExp(`(${regVar}\\/)(.+)`),
          (match, capture1, capture2) => `${capture1}any(s:s/${capture2}`
        );
      return modifiedString + ")";
    });

    occurrences.forEach((extracted, index) => {
      filter = filter.replace(extracted, modifiedArr[index]);
    });
  }
  return filter;
}

function convertDatagridFilterNestedGajiDetails(filter) {
  /*
          filter asli yang dibuat oleh devextreme = pegawaiGajiDetails[0]/id eq 734
          yang ok adalah 
          pegawaiGajiDetails/any(s:s/
        */
  const regex = /(\(pegawaiGajiDetails\[\d+\]\/[^)]+\))/g;
  const occurrences = _.uniq(filter.match(regex));
  if (occurrences == null) return filter;
  //biar dapat ['(pegawaiGajiDetails[0]/jml eq 23)', '(pegawaiGajiDetails[1]/jml eq 23)']
  const modifiedArr = occurrences.map((str) => {
    const modifiedString = str
      .replace(/\[\d+\]/g, "")
      .replace(
        /(pegawaiGajiDetails\/)(.+)/,
        (match, capture1, capture2) => `${capture1}any(s:s/${capture2}`
      );
    return modifiedString + ")";
  });
  occurrences.forEach((extracted, index) => {
    filter = filter.replace(extracted, modifiedArr[index]);
  });
  return filter;
}
</script>
